export const LISTENING_ITEM = 'LISTENING_ITEM';
export const SAVE_HISTORY_REQUEST = 'SAVE_HISTORY_REQUEST';
export const SAVE_HISTORY_SUCCESS = 'SAVE_HISTORY_SUCCESS';
export const SAVE_HISTORY_FAILURE = 'SAVE_HISTORY_FAILURE';
export const HISTORY_CLEAR_COUNT_AD = 'HISTORY_CLEAR_COUNT_AD';
export const HISTORY_COUNT_DOWN_AD = 'HISTORY_COUNT_DOWN_AD';
